module.exports = __webpack_public_path__ + "img/nav-vehcile-models-homepage-lincoln.680f6b3a.png";